import { Flex, FlexProps } from "@givenwell/components";
import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { createLink } from "@tanstack/react-router";
import { ForwardedRef, forwardRef } from "react";
import { Button, ButtonProps } from "./Button";
import { IconButton, IconButtonProps } from "./IconButton";

export const ButtonLink = createLink(
  forwardRef(function ButtonLink(props: ButtonProps, ref: ForwardedRef<HTMLAnchorElement>) {
    return (
      <Button
        as={"a" as any}
        // @ts-expect-error polymorphic prop
        ref={ref}
        {...props}
      />
    );
  }),
);

export const IconButtonLink = createLink(
  forwardRef(function IconButtonLink(props: IconButtonProps, ref: ForwardedRef<HTMLAnchorElement>) {
    return (
      <IconButton
        as={"a" as any}
        // @ts-expect-error polymorphic prop
        ref={ref}
        {...props}
      />
    );
  }),
);

export const FlexLink = createLink(
  forwardRef(function FlexLink(props: FlexProps, ref: ForwardedRef<HTMLAnchorElement>) {
    return <Flex as={"a" as any} ref={ref} {...props} />;
  }),
);

export const InlineA = styled("a", {
  color: colors.blue600,
  fontWeight: 600,
  "&:hover": {
    textDecoration: "underline",
  },
});

export const InlineLink = createLink(InlineA);
